import {
  TShirtIcon,
  HoodieIcon,
  PantsIcon,
  DressIcon,
  SneakerIcon,
  BootIcon,
  BaseballCapIcon,
  SunglassesIcon,
  BackpackIcon,
  TentIcon,
  MountainsIcon,
  CompassIcon,
} from '@phosphor-icons/react';

/**
 * Curated set of Phosphor icons available to the Outfitting Anchor, mirroring
 * the BannerStrip `iconName` pattern. Kept small (clothing + gear) to limit
 * bundle size; extend as the digi merch team needs more options in Prismic.
 */
export const phosphorIcons = {
  // Clothing / outfitting
  TShirtIcon,
  HoodieIcon,
  PantsIcon,
  DressIcon,
  SneakerIcon,
  BootIcon,
  BaseballCapIcon,
  SunglassesIcon,
  // Gear
  BackpackIcon,
  TentIcon,
  MountainsIcon,
  CompassIcon,
};

export const phosphorIconNames = Object.keys(phosphorIcons);
